export interface MeasurementsStorageKeys {
  offset: string;
  measurements: string;
}

export const buildMeasurementsStorageKeys = (conversationId: string): MeasurementsStorageKeys => {
  const base = `vl:${conversationId}`;
  return {
    offset: `${base}:offset`,
    measurements: `${base}:measurements`
  };
};

export const getInitialMeasurementsCache = (keys: MeasurementsStorageKeys): unknown[] | undefined => {
  try {
    const raw = localStorage.getItem(keys.measurements);
    if (!raw) return undefined;
    const parsed = JSON.parse(raw);
    return Array.isArray(parsed) ? parsed : undefined;
  } catch {
    return undefined;
  }
};

export type SaveTimerRef = React.MutableRefObject<number | null>;

export const createMeasurementsOnChange = (keys: MeasurementsStorageKeys, saveTimerRef: SaveTimerRef) => {
  return (instance: { measurementsCache?: unknown[] }) => {
    if (saveTimerRef.current) window.clearTimeout(saveTimerRef.current);
    saveTimerRef.current = window.setTimeout(() => {
      try {
        const cache = instance.measurementsCache ?? [];
        localStorage.setItem(keys.measurements, JSON.stringify(cache));
      } catch {
        // ignore storage errors
      }
    }, 200);
  };
};

export const clearSaveTimer = (saveTimerRef: SaveTimerRef) => {
  if (saveTimerRef.current) {
    window.clearTimeout(saveTimerRef.current);
    saveTimerRef.current = null;
  }
};
